/**
 * Form dropdown options for Prospect Desk forms
 * These options are used across CreateNewProspect and Prospect Details forms
 */

/**
 * Labels type for i18n support
 */
type Labels = Record<string, string> | undefined;

/**
 * i18n Configuration
 * List of constant variables that should be included for translation.
 * Brand names, product names, and identifiers should NOT be included.
 */
export const I18N_TRANSLATABLE_CONSTANTS = [
  'titleOptions',
  'purchaseTypeOptions',
  'financeTypeOptions',
  'purchaseTimingOptions',
  'preferredContactMethodOptions',
  'emailConsentOptions',
  'phoneConsentOptions',
  'testDriveTimeOptions',
  'statusOptions',
] as const;

/**
 * Car manufacturer options
 */
export const carMakerOptions = [
  { label: 'Acura', value: 'ACURA' },
  { label: 'Aiways', value: 'AIWAYS' },
  { label: 'Alfa Romeo', value: 'ALFA ROMEO' },
  { label: 'Aston Martin', value: 'ASTON MARTIN' },
  { label: 'Audi', value: 'AUDI' },
  { label: 'Bentley', value: 'BENTLEY' },
  { label: 'BMW', value: 'BMW' },
  { label: 'BMW Alpina', value: 'BMW-ALPINA' },
  { label: 'Bugatti', value: 'BUGATTI' },
  { label: 'Buick', value: 'BUICK' },
  { label: 'BYD', value: 'BYD' },
  { label: 'Cadillac', value: 'CADILLAC' },
  { label: 'Chevrolet', value: 'CHEVROLET' },
  { label: 'Chrysler', value: 'CHRYSLER' },
  { label: 'Citroen', value: 'CITROEN' },
  { label: 'Cupra', value: 'CUPRA' },
  { label: 'Dacia', value: 'DACIA' },
  { label: 'Daewoo', value: 'DAEWOO' },
  { label: 'Did not Collect', value: 'Did not Collect' },
  { label: 'Dodge', value: 'DODGE' },
  { label: 'DS', value: 'DS' },
  { label: 'Ferrari', value: 'FERRARI' },
  { label: 'Fiat', value: 'FIAT' },
  { label: 'Fisker', value: 'FISKER' },
  { label: 'Ford', value: 'FORD' },
  { label: 'Genesis', value: 'GENESIS' },
  { label: 'GMC', value: 'GMC' },
  { label: 'Honda', value: 'HONDA' },
  { label: 'Hongqi', value: 'HONGQI' },
  { label: 'Hyundai', value: 'HYUNDAI' },
  { label: 'Infiniti', value: 'INFINITI' },
  { label: 'Jaguar', value: 'JAGUAR' },
  { label: 'Jeep', value: 'JEEP' },
  { label: 'Kia', value: 'KIA' },
  { label: 'Koenigsegg', value: 'KOENIGSEGG' },
  { label: 'KTM', value: 'KTM' },
  { label: 'Lamborghini', value: 'LAMBORGHINI' },
  { label: 'Lancia', value: 'LANCIA' },
  { label: 'Land Rover', value: 'LAND ROVER' },
  { label: 'Lexus', value: 'LEXUS' },
  { label: 'Lincoln', value: 'LINCOLN' },
  { label: 'Lotus', value: 'LOTUS' },
  { label: 'Lucid', value: 'LUCID' },
  { label: 'Lynk & Co', value: 'LYNK & CO' },
  { label: 'Maserati', value: 'MASERATI' },
  { label: 'Maybach', value: 'MAYBACH' },
  { label: 'Mazda', value: 'MAZDA' },
  { label: 'McLaren', value: 'MCLAREN' },
  { label: 'Mercedes-Benz', value: 'MERCEDES-BENZ' },
  { label: 'MG', value: 'MG' },
  { label: 'Mini', value: 'MINI' },
  { label: 'Mitsubishi', value: 'MITSUBISHI' },
  { label: 'Nio', value: 'NIO' },
  { label: 'Nissan', value: 'NISSAN' },
  { label: 'Opel', value: 'OPEL' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Peugeot', value: 'PEUGEOT' },
  { label: 'Polestar', value: 'POLESTAR' },
  { label: 'Porsche', value: 'PORSCHE' },
  { label: 'Ram', value: 'RAM' },
  { label: 'Renault', value: 'RENAULT' },
  { label: 'Rimac', value: 'RIMAC' },
  { label: 'Rivian', value: 'RIVIAN' },
  { label: 'Rolls Royce', value: 'ROLLS ROYCE' },
  { label: 'Saab', value: 'SAAB' },
  { label: 'Seat', value: 'SEAT' },
  { label: 'Skoda', value: 'SKODA' },
  { label: 'Smart', value: 'SMART' },
  { label: 'Subaru', value: 'SUBARU' },
  { label: 'Suzuki', value: 'SUZUKI' },
  { label: 'Tesla', value: 'TESLA' },
  { label: 'Toyota', value: 'TOYOTA' },
  { label: 'VinFast', value: 'VINFAST' },
  { label: 'Volkswagen', value: 'VOLKSWAGEN' },
  { label: 'Volvo', value: 'VOLVO' },
  { label: 'Voyah', value: 'VOYAH' },
  { label: 'Xpeng', value: 'XPENG' },
  { label: 'Zeekr', value: 'ZEEKR' },
];

export { getTitleOptions } from '../../constants/constants';

import { getTitleOptions as _getTitleOptions } from '../../constants/constants';

/** @deprecated Use getTitleOptions(labels, locale) instead */
export const titleOptions = _getTitleOptions();

/**
 * Lucid vehicle model options
 */
export const interestedModelOptions = [
  { label: 'Lucid Air Pure', value: 'Lucid Air Pure' },
  { label: 'Lucid Air Touring', value: 'Lucid Air Touring' },
  { label: 'Lucid Air Grand Touring', value: 'Lucid Air Grand Touring' },
  { label: 'Lucid Air Dream Edition', value: 'Lucid Air Dream Edition' },
  { label: 'Lucid Air Sapphire', value: 'Lucid Air Sapphire' },
  { label: 'Lucid Gravity Touring', value: 'Lucid Gravity Touring' },
  { label: 'Lucid Gravity Grand Touring', value: 'Lucid Gravity Grand Touring' },
];

/**
 * Purchase type options
 * @param labels - i18n labels from Contentful
 */
export const getPurchaseTypeOptions = (labels?: Labels) => [
  { label: labels?.['const.purchaseTypeOptions.private'] ?? 'Private', value: 'Private' },
  { label: labels?.['const.purchaseTypeOptions.business'] ?? 'Business', value: 'Business' },
];

/** @deprecated Use getPurchaseTypeOptions(labels) instead */
export const purchaseTypeOptions = getPurchaseTypeOptions();

/**
 * Finance type options
 * @param labels - i18n labels from Contentful
 */
export const getFinanceTypeOptions = (labels?: Labels) => [
  { label: labels?.['const.financeTypeOptions.cash'] ?? 'Cash', value: 'Cash' },
  { label: labels?.['const.financeTypeOptions.lease'] ?? 'Lease', value: 'Lease' },
  { label: labels?.['const.financeTypeOptions.loan'] ?? 'Loan', value: 'Purchase' },
  {
    label: labels?.['const.financeTypeOptions.thirdPartyFinancing'] ?? '3rd Party Financing',
    value: 'Self-arranged Finance',
  },
  { label: labels?.['const.financeTypeOptions.undecided'] ?? 'Undecided', value: 'Undecided' },
];

/** @deprecated Use getFinanceTypeOptions(labels) instead */
export const financeTypeOptions = getFinanceTypeOptions();

/**
 * Purchase timing options
 * @param labels - i18n labels from Contentful
 * @remarks Updated per AUCTUS-1182 - Aligned with Salesforce timing values
 */
export const getPurchaseTimingOptions = (labels?: Labels) => [
  {
    label: labels?.['const.purchaseTimingOptions.didNotCollect'] ?? 'Did not Collect',
    value: 'Did not Collect',
  },
  { label: labels?.['const.purchaseTimingOptions.q1-26'] ?? 'Q1 26', value: 'Q1 26' },
  { label: labels?.['const.purchaseTimingOptions.q2-26'] ?? 'Q2 26', value: 'Q2 26' },
  { label: labels?.['const.purchaseTimingOptions.q3-26'] ?? 'Q3 26', value: 'Q3 26' },
  { label: labels?.['const.purchaseTimingOptions.q4-26'] ?? 'Q4 26', value: 'Q4 26' },
  { label: labels?.['const.purchaseTimingOptions.q1-27'] ?? 'Q1 27', value: 'Q1 27' },
  { label: labels?.['const.purchaseTimingOptions.q2-27'] ?? 'Q2 27', value: 'Q2 27' },
  { label: labels?.['const.purchaseTimingOptions.q3-27'] ?? 'Q3 27', value: 'Q3 27' },
  { label: labels?.['const.purchaseTimingOptions.q4-27'] ?? 'Q4 27', value: 'Q4 27' },
  { label: labels?.['const.purchaseTimingOptions.q1-28'] ?? 'Q1 28', value: 'Q1 28' },
  { label: labels?.['const.purchaseTimingOptions.q2-28'] ?? 'Q2 28', value: 'Q2 28' },
  { label: labels?.['const.purchaseTimingOptions.q3-28'] ?? 'Q3 28', value: 'Q3 28' },
  { label: labels?.['const.purchaseTimingOptions.q4-28'] ?? 'Q4 28', value: 'Q4 28' },
  { label: labels?.['const.purchaseTimingOptions.immediate'] ?? 'Immediate', value: 'Immediate' },
];

/** @deprecated Use getPurchaseTimingOptions(labels) instead */
export const purchaseTimingOptions = getPurchaseTimingOptions();

/**
 * Preferred contact method options
 * @param labels - i18n labels from Contentful
 */
export const getPreferredContactMethodOptions = (labels?: Labels) => [
  { label: labels?.['const.preferredContactMethodOptions.email'] ?? 'Email', value: 'email' },
  { label: labels?.['const.preferredContactMethodOptions.phone'] ?? 'Phone', value: 'phone' },
  { label: labels?.['const.preferredContactMethodOptions.textsms'] ?? 'Text/SMS', value: 'text' },
];

/** @deprecated Use getPreferredContactMethodOptions(labels) instead */
export const preferredContactMethodOptions = getPreferredContactMethodOptions();

export type ExportHistoryLog = {
  id: string;
  exportedAt: string;
  exporterName: string;
};

export const PROSPECTS_EXPORT_TYPE_INCREMENTAL = 'INCREMENTAL';
export const PROSPECTS_EXPORT_TYPE_ALL = 'ALL';

export const MOCK_EXPORT_HISTORY_LOGS: ExportHistoryLog[] = [
  { id: '1', exportedAt: '2026-03-04T10:15:00Z', exporterName: 'Liam Vermeulen' },
  { id: '2', exportedAt: '2026-02-28T09:30:00Z', exporterName: 'Louis Van den Berghe' },
  { id: '3', exportedAt: '2026-02-22T15:45:00Z', exporterName: 'Julien Van Damme' },
  { id: '4', exportedAt: '2026-02-13T08:00:00Z', exporterName: 'Noah Peeters' },
  { id: '5', exportedAt: '2026-01-26T13:20:00Z', exporterName: 'Louis Van den Berghe' },
  { id: '6', exportedAt: '2026-01-18T11:05:00Z', exporterName: 'Arthur Dupont' },
  { id: '7', exportedAt: '2026-01-11T17:10:00Z', exporterName: 'Julien Van Damme' },
  { id: '8', exportedAt: '2026-01-02T07:40:00Z', exporterName: 'Julien Van Damme' },
];

/**
 * Email consent options
 * @param labels - i18n labels from Contentful
 */
export const getEmailConsentOptions = (labels?: Labels) => [
  { label: labels?.['const.emailConsentOptions.optIn'] ?? 'Opt In', value: 'emailOptIn' },
];

/** @deprecated Use getEmailConsentOptions(labels) instead */
export const emailConsentOptions = getEmailConsentOptions();

/**
 * Phone consent options
 * @param labels - i18n labels from Contentful
 */
export const getPhoneConsentOptions = (labels?: Labels) => [
  { label: labels?.['const.phoneConsentOptions.optIn'] ?? 'Opt In', value: 'callOptIn' },
  { label: labels?.['const.phoneConsentOptions.optOut'] ?? 'Opt Out', value: 'callOptOut' },
];

/** @deprecated Use getPhoneConsentOptions(labels) instead */
export const phoneConsentOptions = getPhoneConsentOptions();

/**
 * Test drive time slot options
 */
export const testDriveTimeOptions = [
  { label: '9:00 - 9:30', value: '9:00-9:30' },
  { label: '9:30 - 10:00', value: '9:30-10:00' },
  { label: '10:00 - 10:30', value: '10:00-10:30' },
  { label: '10:30 - 11:00', value: '10:30-11:00' },
  { label: '11:00 - 11:30', value: '11:00-11:30' },
  { label: '11:30 - 12:00', value: '11:30-12:00' },
  { label: '12:00 - 12:30', value: '12:00-12:30' },
  { label: '12:30 - 13:00', value: '12:30-13:00' },
  { label: '13:00 - 13:30', value: '13:00-13:30' },
  { label: '13:30 - 14:00', value: '13:30-14:00' },
  { label: '14:00 - 14:30', value: '14:00-14:30' },
  { label: '14:30 - 15:00', value: '14:30-15:00' },
  { label: '15:00 - 15:30', value: '15:00-15:30' },
  { label: '15:30 - 16:00', value: '15:30-16:00' },
  { label: '16:00 - 16:30', value: '16:00-16:30' },
  { label: '16:30 - 17:00', value: '16:30-17:00' },
];

/**
 * Test drive status options
 * @param labels - i18n labels from Contentful
 */
export const getStatusOptions = (labels?: Labels) => [
  { label: labels?.['const.statusOptions.requested'] ?? 'Requested', value: 'requested' },
  { label: labels?.['const.statusOptions.scheduled'] ?? 'Scheduled', value: 'scheduled' },
  { label: labels?.['const.statusOptions.completed'] ?? 'Completed', value: 'completed' },
];

/** @deprecated Use getStatusOptions(labels) instead */
export const statusOptions = getStatusOptions();

/**
 * Closed status sub status options
 */
export const getClosedSubStatusOptions = (labels?: Labels) => [
  { label: labels?.['const.closedSubStatus.junk'] ?? 'Junk', value: 'junk' },
  {
    label: labels?.['const.closedSubStatus.notInterested'] ?? 'Not Interested',
    value: 'not_interested',
  },
  {
    label: labels?.['const.closedSubStatus.notQualified'] ?? 'Not Qualified',
    value: 'not_qualified',
  },
  {
    label: labels?.['const.closedSubStatus.notSalesInquiry'] ?? 'Not a Sales Inquiry',
    value: 'not_sales_inquiry',
  },
  {
    label: labels?.['const.closedSubStatus.unresponsive'] ?? 'Unresponsive',
    value: 'unresponsive',
  },
];

/** @deprecated Use getClosedSubStatusOptions(labels) instead */
export const closedSubStatusOptions = getClosedSubStatusOptions();

/**
 * Primary reason options for "Junk" sub status
 */
export const getJunkPrimaryReasons = (labels?: Labels) => [
  {
    label: labels?.['const.primaryReason.invalidEmail'] ?? 'Invalid Email',
    value: 'invalid_email',
  },
];

/** @deprecated Use getJunkPrimaryReasons(labels) instead */
export const junkPrimaryReasons = getJunkPrimaryReasons();

/**
 * Primary reason options for "Not Interested" sub status
 */
export const getNotInterestedPrimaryReasons = (labels?: Labels) => [
  { label: labels?.['const.primaryReason.charging'] ?? 'Charging', value: 'charging' },
  {
    label: labels?.['const.primaryReason.confidenceInCompany'] ?? 'Confidence in Company',
    value: 'confidence_in_company',
  },
  {
    label: labels?.['const.primaryReason.customerExperience'] ?? 'Customer Experience',
    value: 'customer_experience',
  },
  {
    label: labels?.['const.primaryReason.environmental'] ?? 'Environmental',
    value: 'environmental',
  },
  { label: labels?.['const.primaryReason.financing'] ?? 'Financing', value: 'financing' },
  {
    label:
      labels?.['const.primaryReason.purchasedDifferentVehicle'] ?? 'Purchased a Different Vehicle',
    value: 'purchased_different_vehicle',
  },
  {
    label: labels?.['const.primaryReason.serviceNetwork'] ?? 'Service Network',
    value: 'service_network',
  },
  { label: labels?.['const.primaryReason.timing'] ?? 'Timing', value: 'timing' },
  {
    label: labels?.['const.primaryReason.vehicleFeatures'] ?? 'Vehicle Features',
    value: 'vehicle_features',
  },
];

/** @deprecated Use getNotInterestedPrimaryReasons(labels) instead */
export const notInterestedPrimaryReasons = getNotInterestedPrimaryReasons();

/**
 * Primary reason options for "Not Qualified" sub status
 */
export const getNotQualifiedPrimaryReasons = (labels?: Labels) => [
  { label: labels?.['const.primaryReason.b2b'] ?? 'B2B', value: 'b2b' },
  { label: labels?.['const.primaryReason.charging'] ?? 'Charging', value: 'charging' },
  {
    label: labels?.['const.primaryReason.environmental'] ?? 'Environmental',
    value: 'environmental',
  },
  { label: labels?.['const.primaryReason.financing'] ?? 'Financing', value: 'financing' },
  { label: labels?.['const.primaryReason.timing'] ?? 'Timing', value: 'timing' },
  { label: labels?.['const.primaryReason.tradeIn'] ?? 'Trade-In', value: 'trade_in' },
  { label: labels?.['const.primaryReason.other'] ?? 'Other', value: 'other' },
];

/** @deprecated Use getNotQualifiedPrimaryReasons(labels) instead */
export const notQualifiedPrimaryReasons = getNotQualifiedPrimaryReasons();

/**
 * Primary reason options for "Not a Sales Inquiry" sub status
 */
export const getNotSalesInquiryPrimaryReasons = (labels?: Labels) => [
  { label: labels?.['const.primaryReason.vendor'] ?? 'Vendor', value: 'vendor' },
  { label: labels?.['const.primaryReason.applicant'] ?? 'Applicant', value: 'applicant' },
  { label: labels?.['const.primaryReason.media'] ?? 'Media', value: 'media' },
];

/** @deprecated Use getNotSalesInquiryPrimaryReasons(labels) instead */
export const notSalesInquiryPrimaryReasons = getNotSalesInquiryPrimaryReasons();

/**
 * Secondary reason options mapped by primary reason
 */
export const getSecondaryReasonsByPrimary = (
  labels?: Labels
): Record<string, Array<{ label: string; value: string }>> => ({
  // Charging (shared by Not Interested and Not Qualified)
  charging: [
    {
      label:
        labels?.['const.secondaryReason.highInstallationCost'] ??
        'High Installation Cost for Home Charging',
      value: 'high_installation_cost',
    },
    { label: labels?.['const.secondaryReason.charging'] ?? 'Charging', value: 'charging' },
    {
      label:
        labels?.['const.secondaryReason.atHomeChargingAvailability'] ??
        'At home charging availability',
      value: 'at_home_charging_availability',
    },
    {
      label:
        labels?.['const.secondaryReason.noBiDirectionalCharging'] ?? 'No Bi-directional charging',
      value: 'no_bi_directional_charging',
    },
    {
      label: labels?.['const.secondaryReason.preferNacsCharging'] ?? 'Prefer NACS charging',
      value: 'prefer_nacs_charging',
    },
    {
      label:
        labels?.['const.secondaryReason.unsatisfactoryChargingInfrastructure'] ??
        'Unsatisfactory Charging Infrastructure',
      value: 'unsatisfactory_charging_infrastructure',
    },
  ],
  // Confidence in Company (Not Interested)
  confidence_in_company: [
    {
      label: labels?.['const.secondaryReason.companyStock'] ?? 'Company Stock',
      value: 'company_stock',
    },
    {
      label: labels?.['const.secondaryReason.performance'] ?? 'Performance',
      value: 'performance',
    },
    {
      label: labels?.['const.secondaryReason.companyViability'] ?? 'Company viability',
      value: 'company_viability',
    },
    {
      label:
        labels?.['const.secondaryReason.concernsLongTermProductSupport'] ??
        'Concerns with Long term product support',
      value: 'concerns_long_term_product_support',
    },
    {
      label: labels?.['const.secondaryReason.productQualityConcerns'] ?? 'Product Quality Concerns',
      value: 'product_quality_concerns',
    },
  ],
  // Customer Experience (Not Interested)
  customer_experience: [
    {
      label: labels?.['const.secondaryReason.negativeSocialMedia'] ?? 'Negative Social Media',
      value: 'negative_social_media',
    },
    {
      label: labels?.['const.secondaryReason.reviewPost'] ?? 'Review/Post',
      value: 'review_post',
    },
    { label: labels?.['const.secondaryReason.studio'] ?? 'Studio', value: 'studio' },
    {
      label:
        labels?.['const.secondaryReason.poorTestDriveExperience'] ?? 'Poor Test Drive Experience',
      value: 'poor_test_drive_experience',
    },
    {
      label:
        labels?.['const.secondaryReason.salesSpecialistNoDetailedInfo'] ??
        'Sales Specialist could not provide detailed information requested',
      value: 'sales_specialist_no_detailed_info',
    },
    {
      label:
        labels?.['const.secondaryReason.salesSpecialistUnresponsive'] ??
        'Sales Specialist Unresponsive',
      value: 'sales_specialist_unresponsive',
    },
    {
      label:
        labels?.['const.secondaryReason.unableTestDriveAppointment'] ??
        'Unable to get a Test Drive Appointment',
      value: 'unable_test_drive_appointment',
    },
  ],
  // Environmental (shared by Not Interested and Not Qualified)
  environmental: [
    {
      label: labels?.['const.secondaryReason.lackOfTaxRelief'] ?? 'Lack of Tax relief',
      value: 'lack_of_tax_relief',
    },
    {
      label: labels?.['const.secondaryReason.politicalUncertainty'] ?? 'Political uncertainty',
      value: 'political_uncertainty',
    },
  ],
  // Financing (shared by Not Interested and Not Qualified)
  financing: [
    {
      label:
        labels?.['const.secondaryReason.businessFinancingNotAvailable'] ??
        'Business Financing not available',
      value: 'business_financing_not_available',
    },
    {
      label: labels?.['const.secondaryReason.downpaymentTooHigh'] ?? 'Downpayment too High',
      value: 'downpayment_too_high',
    },
    {
      label:
        labels?.['const.secondaryReason.lackOfSufficientDocsForStipulations'] ??
        'Lack of Sufficient docs for stipulations',
      value: 'lack_of_sufficient_docs_for_stipulations',
    },
    {
      label: labels?.['const.secondaryReason.leasingNotAvailable'] ?? 'Leasing not available',
      value: 'leasing_not_available',
    },
    {
      label: labels?.['const.secondaryReason.notReadyToEngage'] ?? 'Not ready to engage',
      value: 'not_ready_to_engage',
    },
    {
      label: labels?.['const.secondaryReason.paymentTooHigh'] ?? 'Payment Too High',
      value: 'payment_too_high',
    },
    {
      label:
        labels?.['const.secondaryReason.proposedRateOfferedIsTooHigh'] ??
        'Proposed Rate offered is too high',
      value: 'proposed_rate_offered_is_too_high',
    },
    {
      label:
        labels?.['const.secondaryReason.unsaleablePurchaseOption'] ?? 'Unsaleable purchase option',
      value: 'unsaleable_purchase_option',
    },
    {
      label:
        labels?.['const.secondaryReason.unfavorableFinancingTerms'] ??
        'Unfavorable financing terms',
      value: 'unfavorable_financing_terms',
    },
  ],
  // Purchased a Different Vehicle (Not Interested)
  purchased_different_vehicle: [
    { label: labels?.['const.secondaryReason.otherEv'] ?? 'Other EV', value: 'other_ev' },
  ],
  // Service Network (Not Interested)
  service_network: [
    {
      label:
        labels?.['const.secondaryReason.limitedPhysicalLocations'] ?? 'Limited Physical Locations',
      value: 'limited_physical_locations',
    },
    {
      label: labels?.['const.secondaryReason.notPresentInMarket'] ?? 'Not Present in market',
      value: 'not_present_in_market',
    },
    {
      label:
        labels?.['const.secondaryReason.outOfMobileServiceLocations'] ??
        'Out of Mobile Service Locations',
      value: 'out_of_mobile_service_locations',
    },
    {
      label: labels?.['const.secondaryReason.warrantyConcerns'] ?? 'Warranty concerns',
      value: 'warranty_concerns',
    },
  ],
  // Timing (shared by Not Interested and Not Qualified)
  timing: [
    {
      label: labels?.['const.secondaryReason.extendingCurrentLease'] ?? 'Extending Current Lease',
      value: 'extending_current_lease',
    },
    {
      label: labels?.['const.secondaryReason.needVehicleSooner'] ?? 'Need a vehicle sooner',
      value: 'need_vehicle_sooner',
    },
    {
      label:
        labels?.['const.secondaryReason.remainingInCurrentVehicle'] ??
        'Remaining in Current Vehicle',
      value: 'remaining_in_current_vehicle',
    },
    {
      label: labels?.['const.secondaryReason.notReadyToEngage'] ?? 'Not ready to engage',
      value: 'not_ready_to_engage',
    },
    {
      label: labels?.['const.secondaryReason.tradeInNotAvailable'] ?? 'Trade-In not available',
      value: 'trade_in_not_available',
    },
  ],
  // Vehicle Features (Not Interested)
  vehicle_features: [
    {
      label: labels?.['const.secondaryReason.autonomousDriving'] ?? 'Autonomous Driving',
      value: 'autonomous_driving',
    },
    {
      label: labels?.['const.secondaryReason.batteryDegradation'] ?? 'Battery degradation',
      value: 'battery_degradation',
    },
    {
      label: labels?.['const.secondaryReason.colourOptions'] ?? 'Colour options',
      value: 'colour_options',
    },
    {
      label: labels?.['const.secondaryReason.comfortAccessibility'] ?? 'Comfort/Accessibility',
      value: 'comfort_accessibility',
    },
    {
      label: labels?.['const.secondaryReason.headUpDisplay'] ?? 'Head-up display',
      value: 'head_up_display',
    },
    { label: labels?.['const.secondaryReason.range'] ?? 'Range', value: 'range' },
    { label: labels?.['const.secondaryReason.safety'] ?? 'Safety', value: 'safety' },
    {
      label: labels?.['const.secondaryReason.securityFeatures'] ?? 'Security Features',
      value: 'security_features',
    },
    { label: labels?.['const.secondaryReason.suspension'] ?? 'Suspension', value: 'suspension' },
    { label: labels?.['const.secondaryReason.towing'] ?? 'Towing', value: 'towing' },
    {
      label: labels?.['const.secondaryReason.utilityStorage'] ?? 'Utility & Storage',
      value: 'utility_storage',
    },
    {
      label: labels?.['const.secondaryReason.softwareFeatures'] ?? 'Software features',
      value: 'software_features',
    },
  ],
  // B2B (Not Qualified)
  b2b: [
    {
      label: labels?.['const.secondaryReason.notAvailableOnCompany'] ?? 'Not available on Company',
      value: 'not_available_on_company',
    },
    {
      label: labels?.['const.secondaryReason.rateNotFavorable'] ?? 'Rate not favorable',
      value: 'rate_not_favorable',
    },
  ],
  // Trade-In (Not Qualified)
  trade_in: [
    {
      label:
        labels?.['const.secondaryReason.vehicleNotEligibleTradeIn'] ??
        'Customer vehicle not eligible for trade-in',
      value: 'vehicle_not_eligible_trade_in',
    },
    {
      label: labels?.['const.secondaryReason.negativeEquity'] ?? 'Negative Equity',
      value: 'negative_equity',
    },
    {
      label: labels?.['const.secondaryReason.offerTooLow'] ?? 'Offer Too Low',
      value: 'offer_too_low',
    },
    {
      label: labels?.['const.secondaryReason.tradeInNotAvailable'] ?? 'Trade-In not available',
      value: 'trade_in_not_available',
    },
  ],
  // Other (Not Qualified)
  other: [
    {
      label: labels?.['const.secondaryReason.vehicleFeatures'] ?? 'Vehicle Features',
      value: 'vehicle_features',
    },
    {
      label: labels?.['const.secondaryReason.confidenceInCompany'] ?? 'Confidence in Company',
      value: 'confidence_in_company',
    },
    {
      label: labels?.['const.secondaryReason.customerExperience'] ?? 'Customer Experience',
      value: 'customer_experience',
    },
    {
      label:
        labels?.['const.secondaryReason.purchasedDifferentVeServiceNetwork'] ??
        'Purchased a Different Ve Service Network',
      value: 'purchased_different_ve_service_network',
    },
  ],
});

/** @deprecated Use getSecondaryReasonsByPrimary(labels) instead */
export const secondaryReasonsByPrimary = getSecondaryReasonsByPrimary();

/**
 * Sub statuses that require primary/secondary reasons
 */
export const subStatusesWithReasons = [
  'junk',
  'not_interested',
  'not_qualified',
  'not_sales_inquiry',
];

/**
 * Primary reasons that require secondary reasons
 */
export const primaryReasonsWithSecondary = [
  'charging',
  'confidence_in_company',
  'customer_experience',
  'environmental',
  'financing',
  'purchased_different_vehicle',
  'service_network',
  'timing',
  'vehicle_features',
  'b2b',
  'trade_in',
  'other',
];
